module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 10,
	"op": 56,
	"w": 86,
	"h": 86,
	"nm": "IconProcess_Loop_03_Lottie",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Rectangle 3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						74.438,
						17.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						31.438,
						-25.5,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ind": 0,
					"ty": "sh",
					"ix": 1,
					"ks": {
						"a": 0,
						"k": {
							"i": [
								[
									-3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									-3.097
								],
								[
									0,
									0
								],
								[
									3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									3.097
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									0,
									0
								],
								[
									3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									3.097
								],
								[
									0,
									0
								],
								[
									-3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									-3.097
								]
							],
							"v": [
								[
									-23.73,
									-25.465
								],
								[
									23.73,
									-25.465
								],
								[
									29.338,
									-19.857
								],
								[
									29.338,
									19.857
								],
								[
									23.73,
									25.465
								],
								[
									-23.73,
									25.465
								],
								[
									-29.338,
									19.857
								],
								[
									-29.338,
									-19.857
								]
							],
							"c": true
						},
						"ix": 2
					},
					"nm": "Path 1",
					"mn": "ADBE Vector Shape - Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 43,
						"ix": 2
					},
					"o": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									20
								]
							},
							{
								"t": 90,
								"s": [
									380
								]
							}
						],
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.188235309077,
							0.341176470588,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 0,
			"op": 1862,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Arrow 2",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.563,
								"y": 0.563
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": -45,
							"s": [
								19.27,
								17.535,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.66,
								"y": 0.66
							},
							"o": {
								"x": 0.327,
								"y": 0.326
							},
							"t": -24.621,
							"s": [
								66.73,
								17.535,
								0
							],
							"to": [
								3.097,
								0,
								0
							],
							"ti": [
								0,
								-3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.656,
								"y": 0.656
							},
							"o": {
								"x": 0.316,
								"y": 0.316
							},
							"t": -20.838,
							"s": [
								72.338,
								23.143,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.666,
								"y": 0.666
							},
							"o": {
								"x": 0.332,
								"y": 0.332
							},
							"t": -3.784,
							"s": [
								72.338,
								62.857,
								0
							],
							"to": [
								0,
								3.097,
								0
							],
							"ti": [
								3.097,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.685,
								"y": 0.685
							},
							"o": {
								"x": 0.341,
								"y": 0.341
							},
							"t": -0.001,
							"s": [
								66.73,
								68.465,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.672,
								"y": 0.672
							},
							"o": {
								"x": 0.338,
								"y": 0.338
							},
							"t": 20.379,
							"s": [
								19.27,
								68.465,
								0
							],
							"to": [
								-3.097,
								0,
								0
							],
							"ti": [
								0,
								3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.755,
								"y": 0.755
							},
							"o": {
								"x": 0.394,
								"y": 0.394
							},
							"t": 24.162,
							"s": [
								13.662,
								62.857,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.411,
								"y": 0.411
							},
							"t": 41.217,
							"s": [
								13.662,
								23.143,
								0
							],
							"to": [
								0,
								-3.097,
								0
							],
							"ti": [
								-3.097,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.563,
								"y": 0.563
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 45,
							"s": [
								19.27,
								17.535,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.66,
								"y": 0.66
							},
							"o": {
								"x": 0.327,
								"y": 0.326
							},
							"t": 65.379,
							"s": [
								66.73,
								17.535,
								0
							],
							"to": [
								3.097,
								0,
								0
							],
							"ti": [
								0,
								-3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.656,
								"y": 0.656
							},
							"o": {
								"x": 0.316,
								"y": 0.316
							},
							"t": 69.162,
							"s": [
								72.338,
								23.143,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.666,
								"y": 0.666
							},
							"o": {
								"x": 0.332,
								"y": 0.332
							},
							"t": 86.216,
							"s": [
								72.338,
								62.857,
								0
							],
							"to": [
								0,
								3.097,
								0
							],
							"ti": [
								3.097,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.685,
								"y": 0.685
							},
							"o": {
								"x": 0.341,
								"y": 0.341
							},
							"t": 89.999,
							"s": [
								66.73,
								68.465,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.672,
								"y": 0.672
							},
							"o": {
								"x": 0.338,
								"y": 0.338
							},
							"t": 110.379,
							"s": [
								19.27,
								68.465,
								0
							],
							"to": [
								-3.097,
								0,
								0
							],
							"ti": [
								0,
								3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.755,
								"y": 0.755
							},
							"o": {
								"x": 0.394,
								"y": 0.394
							},
							"t": 114.162,
							"s": [
								13.662,
								62.857,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.411,
								"y": 0.411
							},
							"t": 131.217,
							"s": [
								13.662,
								23.143,
								0
							],
							"to": [
								0,
								-3.097,
								0
							],
							"ti": [
								-3.097,
								0,
								0
							]
						},
						{
							"t": 135,
							"s": [
								19.27,
								17.535,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						75.023,
						17.328,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 1,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-5.729,
											-11.339
										],
										[
											5.729,
											0.118
										],
										[
											-5.492,
											11.339
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 10,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 90,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									69.287,
									17.203
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": -45,
			"op": 1817,
			"st": -45,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Rectangle 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						74.438,
						17.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						31.438,
						-25.5,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ind": 0,
					"ty": "sh",
					"ix": 1,
					"ks": {
						"a": 0,
						"k": {
							"i": [
								[
									-3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									-3.097
								],
								[
									0,
									0
								],
								[
									3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									3.097
								],
								[
									0,
									0
								]
							],
							"o": [
								[
									0,
									0
								],
								[
									3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									3.097
								],
								[
									0,
									0
								],
								[
									-3.097,
									0
								],
								[
									0,
									0
								],
								[
									0,
									-3.097
								]
							],
							"v": [
								[
									-23.73,
									-25.465
								],
								[
									23.73,
									-25.465
								],
								[
									29.338,
									-19.857
								],
								[
									29.338,
									19.857
								],
								[
									23.73,
									25.465
								],
								[
									-23.73,
									25.465
								],
								[
									-29.338,
									19.857
								],
								[
									-29.338,
									-19.857
								]
							],
							"c": true
						},
						"ix": 2
					},
					"nm": "Path 1",
					"mn": "ADBE Vector Shape - Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 43,
						"ix": 2
					},
					"o": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.833
									],
									"y": [
										0.833
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 0,
								"s": [
									-160
								]
							},
							{
								"t": 90,
								"s": [
									200
								]
							}
						],
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.188235309077,
							0.341176470588,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 0,
			"op": 1862,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Arrow 1",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.563,
								"y": 0.563
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 0,
							"s": [
								19.27,
								17.535,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.66,
								"y": 0.66
							},
							"o": {
								"x": 0.327,
								"y": 0.326
							},
							"t": 20.379,
							"s": [
								66.73,
								17.535,
								0
							],
							"to": [
								3.097,
								0,
								0
							],
							"ti": [
								0,
								-3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.656,
								"y": 0.656
							},
							"o": {
								"x": 0.316,
								"y": 0.316
							},
							"t": 24.162,
							"s": [
								72.338,
								23.143,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.666,
								"y": 0.666
							},
							"o": {
								"x": 0.332,
								"y": 0.332
							},
							"t": 41.216,
							"s": [
								72.338,
								62.857,
								0
							],
							"to": [
								0,
								3.097,
								0
							],
							"ti": [
								3.097,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.685,
								"y": 0.685
							},
							"o": {
								"x": 0.341,
								"y": 0.341
							},
							"t": 44.999,
							"s": [
								66.73,
								68.465,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.672,
								"y": 0.672
							},
							"o": {
								"x": 0.338,
								"y": 0.338
							},
							"t": 65.379,
							"s": [
								19.27,
								68.465,
								0
							],
							"to": [
								-3.097,
								0,
								0
							],
							"ti": [
								0,
								3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.755,
								"y": 0.755
							},
							"o": {
								"x": 0.394,
								"y": 0.394
							},
							"t": 69.162,
							"s": [
								13.662,
								62.857,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.411,
								"y": 0.411
							},
							"t": 86.217,
							"s": [
								13.662,
								23.143,
								0
							],
							"to": [
								0,
								-3.097,
								0
							],
							"ti": [
								-3.097,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.563,
								"y": 0.563
							},
							"o": {
								"x": 0.167,
								"y": 0.167
							},
							"t": 90,
							"s": [
								19.27,
								17.535,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.66,
								"y": 0.66
							},
							"o": {
								"x": 0.327,
								"y": 0.326
							},
							"t": 110.379,
							"s": [
								66.73,
								17.535,
								0
							],
							"to": [
								3.097,
								0,
								0
							],
							"ti": [
								0,
								-3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.656,
								"y": 0.656
							},
							"o": {
								"x": 0.316,
								"y": 0.316
							},
							"t": 114.162,
							"s": [
								72.338,
								23.143,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.666,
								"y": 0.666
							},
							"o": {
								"x": 0.332,
								"y": 0.332
							},
							"t": 131.216,
							"s": [
								72.338,
								62.857,
								0
							],
							"to": [
								0,
								3.097,
								0
							],
							"ti": [
								3.097,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.685,
								"y": 0.685
							},
							"o": {
								"x": 0.341,
								"y": 0.341
							},
							"t": 134.999,
							"s": [
								66.73,
								68.465,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.672,
								"y": 0.672
							},
							"o": {
								"x": 0.338,
								"y": 0.338
							},
							"t": 155.379,
							"s": [
								19.27,
								68.465,
								0
							],
							"to": [
								-3.097,
								0,
								0
							],
							"ti": [
								0,
								3.097,
								0
							]
						},
						{
							"i": {
								"x": 0.755,
								"y": 0.755
							},
							"o": {
								"x": 0.394,
								"y": 0.394
							},
							"t": 159.162,
							"s": [
								13.662,
								62.857,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"i": {
								"x": 0.833,
								"y": 0.833
							},
							"o": {
								"x": 0.411,
								"y": 0.411
							},
							"t": 176.217,
							"s": [
								13.662,
								23.143,
								0
							],
							"to": [
								0,
								-3.097,
								0
							],
							"ti": [
								-3.097,
								0,
								0
							]
						},
						{
							"t": 180,
							"s": [
								19.27,
								17.535,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						75.023,
						17.328,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 1,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-5.729,
											-11.339
										],
										[
											5.729,
											0.118
										],
										[
											-5.492,
											11.339
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 10,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 90,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									69.287,
									17.203
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 1862,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/IconProcess_Loop_03_Lottie.json
// module id = 650
// module chunks = 0